import React from "react";
import logo from ".././images/tash logo no background.png";
import { Link } from "react-router-dom";
// import "./Navbar.css";

// Set path and text for navbar elements
const pages = [
  { name: "About Us", path: "/" },
//   { name: "Services", path: "/assessment-information" },
  // { name: "Location", path: "/location" }
//   ,
  { name: "Contact", path: "/contact" }
];

function Navbar() {
  return (
    <nav id="navbar">
        <Link to="/" className="navbar-item">
            <div className="logo_container">
                <img src={logo} className="logo"  alt="Tash Work Assessments" />
            </div>
        </Link>
        {pages.map((page, idx) => (
            <Link
            className={`navbar-item${idx === 0 ? " title_first_elements" : ""} title_elements`}
            key={page.name}
            to={page.path}
            >
                {page.name}
            </Link>
        ))}
    </nav>
  );
}

export default Navbar;